import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const MoreToggle = ({ open, setOpen, ...props }) => {
  return (
    <span
      className="bg-light-gray rounded-sm ml-2 text-dark font-normal hover:bg-light-green cursor-pointer"
      onClick={() => setOpen(!open)}
      {...props}
    >
      <FontAwesomeIcon
        className="inline w-4 h-4 pr-1"
        icon={open ? faChevronUp : faChevronDown}
        fill="currentColor"
        aria-hidden="true"
      />{" "}
      {open ? "minder" : "meer..."}
    </span>
  );
};
